import { createContext, useContext, useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import BackendService from "../service/BackendService";
import UsersRepository from "../data/repository/UsersRepository";
import UsersService from "../data/services/UsersService";
import Loading from "../Components/Loading/Loading";

const StoreContext = createContext();

export function DataProvider({ children }) {
  const history = useHistory();
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const backendService = useMemo(() => new BackendService(), []);
  const usersRepository = useMemo(() => new UsersRepository(), []);
  const usersService = useMemo(
    () => new UsersService(usersRepository),
    [usersRepository]
  );

  const redirectToLogin = () => {
    backendService.setAccessToken(null);
    history.replace("/login");
    setLoading(false);
  };

  const getUserProfile = async () => {
    const user = await usersService.getUserProfile();
    if (user) {
      setCurrentUser(user);
    } else {
      redirectToLogin();
    }
  };

  const initializeAuth = async () => {
    const accessToken = backendService.getAccessToken();

    try {
      if (accessToken) {
        await getUserProfile();
      } else {
        redirectToLogin();
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
      redirectToLogin();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    initializeAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <StoreContext.Provider value={{ currentUser }}>
      {children}
    </StoreContext.Provider>
  );
}

export function useData() {
  return useContext(StoreContext);
}
